export default function getHxsmsTokenStorage() {
  return sessionStorage.getItem("hxsmsToken")
    ? sessionStorage.getItem("hxsmsToken")
    : null;
}
